export default __webpack_public_path__ + "static/media/map-screenshot-mock.7eb6e417.png";